// generated by genversion
export const version = '0.33.3';
//# sourceMappingURL=version.js.map